// Shared horizontal sizing for the NoticeIA viewer column: full width on
// mobile, a centered 40% column on desktop (~30% margin each side). Used by the
// upload drop zone, the open viewer frame, and the page Q&A so they all line up
// by construction rather than repeating the width in each place.
export const SECTION_WIDTH = 'w-full md:mx-auto md:w-2/5';
